import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Row, Col } from 'react-bootstrap';
import each from 'lodash/each';
import pluralize from 'pluralize';

import Alert from 'components/alert';

export default class ImportPreview extends React.Component {
  static propTypes = {
    errors: PropTypes.array.isRequired,
    fieldColumnLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
    fileName: PropTypes.string.isRequired,
    objectName: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
  }

  fieldNames() {
    return this.props.fieldColumnLabels.join(', ');
  }

  render() {
    const { fileName, rowCount, objectName } = this.props;

    return (
      <React.Fragment>
        <p>
          The following fields will be imported into Buildout. If everything looks good, you can start your import.
        </p>
        <h4 className="mb-4 mt-5 text-uppercase text-muted">
          <strong>{fileName}</strong>
        </h4>
        {this.renderErrors()}
        <Panel>
          <Panel.Body>
            <Row>
              <Col md={3} sm={4} xs={5}>
                <div className="separator-right">
                  <p>Buildout will import:</p>
                  <div>
                    <strong name="rowCount">{pluralize(objectName, rowCount, true)}</strong>
                  </div>
                </div>
              </Col>
              <Col md={9} sm={8} xs={7}>
                <p>Buildout will import data from these fields:</p>
                <div>
                  <strong name="fieldNames">{this.fieldNames()}</strong>
                </div>
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </React.Fragment>
    );
  }

  renderErrors() {
    if (this.props.errors.length === 0) return;

    return (
      <Alert
        messages={this.props.errors}
        title="There were errors in your CSV mapping that prevented the import from starting."
      />
    );
  }
}
